import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import ScrollTrigger from 'react-scroll-trigger';
import moment from 'moment';
import 'moment-timezone';

import { resetCompanyDataTimeline, fetchCompanyDataTimeline } from 'actions/ClientsActions';
import Loader from 'components/layout/Loader';
import IntlDate from 'components/layout/IntlDate';
import IntlDateRelative from 'components/layout/IntlDateRelative';

class Timeline extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      resPerPage: 10,
    };
  }

  componentWillMount = () => {
    const { resetData } = this.props;
    resetData();
    this.loadData();
  };

  loadMore = () => {
    this.setState(
      prevState => ({ page: prevState.page + 1 }),
      () => {
        this.loadData();
      }
    );
  };

  loadData = () => {
    const { fetchData, clientId } = this.props;
    const { page, resPerPage } = this.state;

    fetchData(clientId, page, resPerPage);
  };

  render() {
    const {
      intl: { messages },
      companyDataTimeline,
    } = this.props;

    const pending = companyDataTimeline?.isLoading;
    const momentWeekAgo = moment()
      .subtract(7, 'days')
      .startOf('day');

    const eventList = [];
    companyDataTimeline?.events?.events?.map(event => {
      const eventDate = moment(event.cdate).isAfter(momentWeekAgo) ? (
        <IntlDateRelative date={event.cdate} />
      ) : (
        <IntlDate date={event.cdate} />
      );
      eventList.push(
        <ScrollTrigger className="timeline-block">
          <div className={'timeline-point warning text-center bounce-in'}>
            <i className="far fa-sticky-note fa-fw" />
          </div>

          <div className={'timeline-content bounce-in '}>
            <div className="card share full-width">
              <div style={{ padding: '15px' }}>
                <Row style={{ marginBottom: '5px', borderBottom: '1px solid beige' }}>
                  <Col xs={4}>
                    <b>{messages.company}</b>
                  </Col>
                  <Col xs={8}>{event.company}</Col>
                </Row>
                <Row style={{ marginBottom: '5px', borderBottom: '1px solid beige' }}>
                  <Col xs={4}>
                    <b>{messages.company_name}</b>
                  </Col>
                  <Col xs={8}>{event.company_name}</Col>
                </Row>
                <Row style={{ marginBottom: '5px', borderBottom: '1px solid beige' }}>
                  <Col xs={4}>
                    <b>{messages.debtor_number}</b>
                  </Col>
                  <Col xs={8}>{event.debtor_number}</Col>
                </Row>
                <Row style={{ marginBottom: '5px', borderBottom: '1px solid beige' }}>
                  <Col xs={4}>
                    <b>{messages.updated_by}</b>
                  </Col>
                  <Col xs={8}>{event.created_by}</Col>
                </Row>
              </div>
            </div>
            <div className="event-date">
              <small className="fs-12 hint-text">{eventDate}</small>
            </div>
          </div>
        </ScrollTrigger>
      );
    });

    let loadMore;
    if (!pending && companyDataTimeline?.events?.events?.length < companyDataTimeline?.events?.count) {
      loadMore = (
        <Row>
          <Col xs={12}>
            <div className="text-center">
              <Button onClick={this.loadMore}>{messages.load_more}</Button>
            </div>
          </Col>
        </Row>
      );
    } else if (pending) {
      loadMore = <Loader />;
    }

    return (
      <div className="bg-master-lighter">
        <div className="timeline-container top-circle p-b-30">
          <section className="timeline">{eventList}</section>

          {loadMore}
        </div>
      </div>
    );
  }
}

Timeline.defaultProps = {
  timezone: 'UTC',
};

const mapStateToProps = state => {
  return {
    companyDataTimeline: state.companyDataTimeline,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    resetData: () => {
      dispatch(resetCompanyDataTimeline());
    },
    fetchData: (clientId, page, resPerPage) => {
      dispatch(fetchCompanyDataTimeline(clientId, (page - 1) * resPerPage, resPerPage));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Timeline)
);
